<template>
    <div
        v-show="show"
        class="cookiewall"
    >
        <div
            v-if="!showMore"
        >
            <h3 v-html="lang('cookiewall.default.header')"></h3>
            <p v-html="lang('cookiewall.default.body')"></p>

            <div class="text-center">
                <button
                    class="btn btn-primary"
                    @click="acceptAll"
                >Alles accepteren</button>
                <br />
                <button
                    @click="showMore = true"
                    class="btn btn-sm btn-gray"
                >Instellingen</button>
            </div>
        </div>
        <div
            class="settings"
            v-else
        >
            <h3 v-html="lang('cookiewall.settings.header')"></h3>
            <p v-html="lang('cookiewall.settings.body')"></p>
            <div class="text-center">
                <button
                    class="btn btn-primary"
                    @click="acceptAll"
                >Alles accepteren</button>
            </div>
            <h4
                class="mt-4"
                v-html="lang('cookiewall.settings.subheader')"
            ></h4>
            <div
                class="mb-4"
            >
                <div
                    class="form-check"
                    v-for="type in types"
                >
                    <input
                        type="checkbox"
                        name="selection[]"
                        class="form-check-input"
                        :value="type"
                        :id="'cookieconsent-' + type"
                        v-model="selection"
                        :disabled="type === 'default'"
                    />
                    <label
                        :for="'cookieconsent-' + type"
                        class="form-check-label"
                        v-html="lang('cookiewall.settings.types.' + type)"
                    ></label>
                </div>
            </div>
            <div class="text-center">
                <div
                    class="btn btn-sm btn-secondary"
                    @click="acceptSelection"
                >Instellingen opslaan</div>
            </div>
        </div>
    </div>
</template>

<script>

import isbot from 'isbot';
import environment from "../environment";

export default {

    computed: {
        isABot() {
            return isbot(navigator.userAgent);
        },
    },

    data() {
        return {
            cookieconsent_cookiename: "scs_cc",
            selection: ["default"],
            show:false,
            showMore:false,
            types: [
                "default",
                "statistics",
                "advertising",
            ],
        }
    },

    methods: {
        acceptAll() {
            this.acceptThese(JSON.stringify(this.types));
        },
        acceptSelection() {
            this.acceptThese(JSON.stringify(this.selection));
        },
        acceptThese(typesJson) {
            this.$cookie.set(this.cookieconsent_cookiename, typesJson, 3650);
            this.show = false;
            this.showMore = false;
            this.bootServices();
        },

        bootServices() {
            let cookieValue = this.cookieValue();

            if (cookieValue === null) {
                return;
            }

            // Functional cookies

            // Statistics cookies
            if (cookieValue.indexOf("statistics")) {
                this.bootGA4();
            }
        },

        bootGA4() {
            let GA4_TAG = this.$page.props.ga4_tag;
            if (null === GA4_TAG) {
                console.log('Could not load GA4. Missing tag.');
                return;
            }
            let headElement = document.querySelector('head');

            // Create script to load the gtag library
            let scriptElementGtag = document.createElement('script');
            scriptElementGtag.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_TAG;
            scriptElementGtag.async = true;
            headElement.appendChild(scriptElementGtag);

            // Create script element with the content required to load GA4
            let scriptElement = document.createElement('script');
            let ga4Script = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', '${ GA4_TAG }');`;
            let textNode = document.createTextNode(ga4Script);
            scriptElement.appendChild(textNode);
            headElement.appendChild(scriptElement);

            // Create event listener
            this.$inertia.on("navigate", () => {
                gtag("js", new Date());
                gtag("config", GA4_TAG);
            });
        },

        cookieValue() {
            if (this.isABot) {
                return this.types;
            }

            let value = this.$cookie.get(this.cookieconsent_cookiename);

            if (null === value) {
                return null;
            }

            return JSON.parse(value);
        },
    },

    mounted() {
        if (this.cookieValue() === null) {
            this.show = true;
        }

        if (environment === 'production') {
            this.bootServices();
        }
    },

    name: "Cookiewall"

}

</script>
